export default function EnkIwpLogo() {
  return <img src="/iwp-logo.svg" alt="logo" className="h-12 w-auto" />
}
